import request from "@/utils/request";
export function login(data, code) {
  return request({
    url: "/v1/customers/login",
    method: "post",
    data: data,
    headers: {
      "ga-code": code
    }
  });
}
export function loginPerson(data, code) {
  return request({
    url: "/v1/admin/individual/login",
    method: "post",
    data: data
  });
}
export function register(data) {
  return request({
    url: "/v1/customers/register",
    method: "post",
    data: data
  });
}
export function personRegister(data) {
  return request({
    url: "/v1/admin/individual/register",
    method: "post",
    data: data,
    headers: {
      "email-code": data.mail_code
    }
  });
}
export function personResetPassword(data) {
  return request({
    url: "/v1/admin/individual/login/reset",
    method: "put",
    data: data,
    headers: {
      "email-code": data.mail_code
    }
  });
}
export function getInfo() {
  return request({
    url: "/v1/customers/login/info",
    method: "get"
  });
}
export function logout() {
  return request({
    url: "/v1/common/logout",
    method: "get"
  });
}
export function getGaSecret() {
  return request({
    url: "/v1/common/security/google-authentication",
    method: "get"
  });
}
export function bindGa(params, emailCode) {
  return request({
    url: "/v1/common/security/google-authentication",
    method: "PUT",
    params: params,
    headers: {
      "email-code": emailCode
    }
  });
}
export function sendEmailCode() {
  return request({
    url: "/v1/common/security/authentication/mail",
    method: "post"
  });
}
export function sendEmailCodeRegister(email) {
  return request({
    url: "/v1/common/security/mail",
    method: "post",
    data: {
      mail: email
    }
  });
}
export function getGaStatus(mail) {
  return request({
    url: "/v1/common/security",
    method: "get",
    params: {
      mail: mail,
      login_type: 1
    }
  });
}
export function submitResetPassword(data, code) {
  return request({
    url: "/v1/customers/login/reset",
    method: "put",
    data: data,
    headers: {
      "ga-code": code
    }
  });
}
export function changePassword(data, googleCode) {
  return request({
    url: "/v1/customers/login/reset",
    method: "put",
    data: data,
    headers: {
      "ga-code": googleCode
    }
  });
}

// export function getCustUqAccount() {
//   return request({
//     url: "/v1/customers/asset/uq-account",
//     method: "post",
//   });
// }
// export function getCustPhAccount() {
//   return request({
//     url: "/v1/customers/asset/ph-account",
//     method: "post",
//   });
// }